/* eslint-disable */
// Don't check the return type here. This allows `ReturnType<T>` to work


/**
 * Create styles for `<OrderConcreteDeliveries />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderConcreteDeliveries />` styles
 */
const orderConcreteDeliveriesInTransitSectionStyles = ({ theme }) => ({
  detailsContainer: {
    width: `100%`,
  },
  detailsHeader: {
    backgroundColor: `#FFDE00`,
  },
  detailsItemContainer: {
    backgroundColor: theme.palette.grey[100],
    margin: `${theme.spacing(1) / 2}px 0`,
    padding: `${theme.spacing(1)}px ${theme.spacing(1) * 3}px`,
  },
  noPadding: {
    padding: 0,
  },
  section: {
    margin: `-${theme.spacing(1) / 2}px`,
    marginBottom: theme.spacing(1) * 3,
  },
});

export default orderConcreteDeliveriesInTransitSectionStyles;
